export default "__VITE_ASSET__7d55587a__"